const theme = {
  colors: {
    aqua: '#54baa1',
  },
};

export default theme;
